import * as types from '@/store/mutation-types'
import api from '@/services/api/adminClients'
import { handleError } from '@/utils/utils.js'
import { checkIfTokenNeedsRefresh } from '@/utils/utils.js'

const getters = {
  client: state => state.client,
}

const actions = {
  getClientProfile({ commit }, payload) {
    checkIfTokenNeedsRefresh()
    return new Promise((resolve, reject) => {
      commit(types.SHOW_TOP_LOADING, true)
      api
        .getClientProfile(payload._id)
        .then(response => {
          if (response.status === 200) {

            commit(types.CLIENT, response.data.profile)
            commit(types.SHOW_TOP_LOADING, false)
            resolve()
            //commit(types.SHOW_LOADING, false)
          }
        })
        .catch(error => {
          handleError(error, commit, reject)
        })
    })
  }
}

const mutations = {
  [types.CLIENT](state, client) {
    state.client = client
  }
}

const state = {
  client: []
}

export default {
  state,
  getters,
  actions,
  mutations
}
